export const PROCESSES_ERROR = 'PROCESSES_ERROR';
export const PROCESSES_REQUEST = 'PROCESSES_REQUEST';
export const PROCESSES_SUCCESS = 'PROCESSES_SUCCESS';
export const PROCESSES_RESET = 'PROCESSES_RESET';

export const PROCESSES_QUEUE_ERROR = 'PROCESSES_QUEUE_ERROR';
export const PROCESSES_QUEUE_REQUEST = 'PROCESSES_QUEUE_REQUEST';
export const PROCESSES_QUEUE_SUCCESS = 'PROCESSES_QUEUE_SUCCESS';
